'use client'
import Footer from '@/components/Footer';
import usePhoneNumber from '@/hooks/usePhoneNumber';
import 'swiper/css';
import 'swiper/css/pagination';
import MainMenu from '@/components/MainMenu';
import Image from 'next/image'
import Link from 'next/link'
import { use, useCallback, useEffect, useState } from 'react';
import { sendRequest, sendRequestNoToken } from '@/utils/apiService';
import { SpinningSkeletonLoader } from '@/components/skeleton/SpinningSkeleton';
import { Article, formatDateTime } from '@/utils/types';
import Pagination from '@/components/Pagination';
import { prependCoreUrl } from '@/utils/globals';



const Page = ({ params }: { params: Promise<{ url: string }> }) => {
  const { url } = use(params);
  const { phoneNumber, isCookieLoading } = usePhoneNumber();
  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState<Article | null>(null);
  const [isError, setIsError] = useState(false);


  useEffect(() => {
    sendRequestNoToken("POST", `/api/mydesk/`, { "url": url })
      .then((data) => {
        setResult(data.result);
      })
      .catch((error) => {
        setIsError(true)
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [url]);


  if (isError) {
    return <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <h1 className="text-6xl font-bold text-purple-600 mb-4">404</h1>
      <p className="text-xl text-gray-800 dark:text-gray-200 mb-8">
        Таны хандсан хуудас олдсонгүй!
      </p>
      <Link href="/">
        <button className="bg-purple-600 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-purple-700">
          Нүүр хуудас
        </button>
      </Link>
    </div>
  }

  if (result === null) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-dark-800">
      <div className="text-center">
        <div className="spinner-border animate-spin inline-block w-16 h-16 border-8 border-solid border-purple-500 border-t-transparent rounded-full"></div>
        <p className="mt-4 text-xl dark:text-dark-100 text-gray-700">Уншиж байна...</p>
      </div>
    </div>
  }

  return (
    <main className="flex flex-col items-center justify-between overflow-hidden">
      <MainMenu isLoading={isCookieLoading} phoneNumber={phoneNumber} scrollIndicatorEnabled={true} />
      <section className="text-start pt-10 pb-0 md:pt-24 w-screen justify-start bg-gradient-to-b from-gradient-start to-white dark:from-purple-700 dark:to-dark-800">
        <div className='container mt-20 mb-10 text-start'>
          <div>
            <div className='text-sm font-semibold mb-2 uppercase'>
              <span className='text-purple-500 dark:text-purple-400 pe-2 '>{result.subtitle}</span>
              {formatDateTime(result.publish_datetime)}</div>
            <div className='text-2xl md:text-4xl font-semibold max-w-[800px]'>
              {result.title}
            </div>
          </div>
        </div>
      </section>
      <section className='min-h-[50vh] w-full bg-white dark:bg-dark-800 pb-10'>
        <div className='container flex flex-col space-y-8 md:space-y-4'>
          {isLoading ? (
            <SpinningSkeletonLoader />
          ) : (
            <>
              <div>
                <Image
                  src={result.image_url}
                  width={0}
                  height={0}
                  alt={''}
                  sizes="100vw"
                  className="h-auto w-full mx-auto"
                />
              </div>

              <div className='max-w-[600px] mx-auto mt-3' dangerouslySetInnerHTML={{ __html: prependCoreUrl(result.text) || "" }} />
            </>
          )}

        </div>
      </section>
      <Footer />
    </main>
  )
}
export default Page;
